import React, { useState, useEffect } from "react";
import {
  ChakraProvider,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Select,
  FormControl,
  FormLabel,
  useToast,
  Text,
} from "@chakra-ui/react";

import ExpertDataService from "../../services/Expert";

export const MonthYearModal = ({ isOpen, onClose, data, id, name }: any) => {

  const toast = useToast();
  const [groupedMonthsYears, setGroupedMonthsYears] = useState<any>({});
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");


  const handleMonthChange = (e: any) => {
    setSelectedMonth(e.target.value);
    setSelectedYear("");
  };

  const handleYearChange = (e: any) => {
    setSelectedYear(e.target.value);
  };

  const handleSubmit = async () => {
    try {
      const response = await ExpertDataService.getExpertBillingPdf(
        id,
        selectedMonth,
        selectedYear
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `${name}-${selectedMonth}-${selectedYear}.pdf`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      setSelectedMonth("");
      setSelectedYear("");
      handleClose();
    } catch (error) {
      toast({
        position: "top",
        title: "Billing Summary Download Failed",
        description:
          "There was an error downloading the billing summary. Please try again later.",
        status: "error",
        duration: 1500,
        isClosable: true,
      });
    }
  };

  const groupByMonth = (monthsYears: any[]) => {
    const grouped: any = {};

    monthsYears.forEach(({ month, year }: any) => {
      if (!grouped[month]) {
        grouped[month] = [];
      }
      grouped[month].push(year);
    });

    return grouped;
  };
  const isEmptyData = data.length === 0;
  const handleClose = () => {
    setGroupedMonthsYears({});
    setSelectedMonth("");
    setSelectedYear("");
    onClose();
  }
  useEffect(() => {
    setGroupedMonthsYears(groupByMonth(data));
  }, [data]);
  return (
    <>
      <Modal isOpen={isOpen} onClose={handleClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Select Month and Year</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {isEmptyData ? (
              <Text>No data available</Text>
            ) : (
              <>
                <FormControl>
                  <FormLabel>Month</FormLabel>
                  <Select
                    placeholder="Select month"
                    onChange={handleMonthChange}
                    value={selectedMonth}
                  >
                    {Object.keys(groupedMonthsYears).map((month, index) => (
                      <option key={index} value={month}>
                        {month}
                      </option>
                    ))}
                  </Select>
                </FormControl>
                {selectedMonth && (
                  <FormControl mt={4}>
                    <FormLabel>Year</FormLabel>
                    <Select
                      placeholder="Select year"
                      onChange={handleYearChange}
                      value={selectedYear}
                    >
                      {groupedMonthsYears[selectedMonth].map(
                        (year: any, index: any) => (
                          <option key={index} value={year}>
                            {year}
                          </option>
                        )
                      )}
                    </Select>
                  </FormControl>
                )}
              </>
            )}
          </ModalBody>

          <ModalFooter>
            <Button
              colorScheme="blue"
              mr={3}
              onClick={handleSubmit}
              disabled={!selectedMonth || !selectedYear || isEmptyData}
            >
              Download
            </Button>
            <Button variant="ghost" onClick={handleClose}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
